import styled from "@emotion/styled";
import COLORS from "styles/colors";
import DropdownArrow from "assets/caret-circle-down.svg";

export const FormLabel = styled.label`
  position: static;
  width: 62px;
  font-style: normal;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 16px;

  color: ${props => (props.color ? props.color : COLORS.primary)};
  svg {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    margin-left: 5px;
  }
`;

export const InputWrapper = styled.div`
  margin-bottom: 15px;
  .phoneInline {
    display: flex;
    height: 53px;
  }
  .profileLabel {
    font-weight: 500;
    font-size: 1.4rem;
    line-height: 16px;
  }
  .radioInput {
    display: flex;
    align-items: center;
    color: ${COLORS.primary};
    span {
      /* margin-right: 32px; */
    }
    input[type="radio"] {
      vertical-align: text-bottom;
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }

  .passwordHint {
    color: red;
    margin-top: 8px;
    font-size: 1.1rem;
  }

  .flagWrapper {
    position: relative;
    svg {
      position: absolute;
      margin: 20px 10px;

      @media all and (max-width: 320px) {
        display: none;
      }
    }
  }
`;
export const Input = styled.input`
  outline: none;
  margin-top: 8px;
  width: 100%;
  font-size: 1.4rem;
  font-weight: 400;
  padding: 0.8rem 1.6rem;
  height: 40px;
  line-height: 2.4rem;
  border: 1px solid ${COLORS.border2};
  background: ${COLORS.fauxAqua};
  border-radius: 4px;
  color: ${COLORS.primary};
  border-color: ${props => (props.error ? "red" : COLORS.border2)};

  ::-webkit-input-placeholder {
    /* Edge */
    color: ${COLORS.border};
    font-weight: 300;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${COLORS.border};
  }
  :focus {
    border: 1px solid ${COLORS.textdark};
  }

  ::placeholder {
    color: ${COLORS.primary};
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const PhoneInput = styled.input`
  margin-top: 8px;
  border-radius: 0px 4px 4px 0px;
  padding: 8px;
  outline: none;
  font-size: 1.4rem;
  height: 40px;
  font-weight: 400;
  padding: 0.8rem 1.6rem;
  border: 1px solid ${COLORS.border2};
  background: ${COLORS.fauxAqua};
  color: ${COLORS.text};
  width: 100%;
  border-color: ${props => (props.error ? "red" : COLORS.border2)};

  ::-webkit-input-placeholder {
    /* Edge */
    color: ${COLORS.border};
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${COLORS.border};
  }

  ::placeholder {
    color: ${COLORS.border};
  }

  :focus {
    border: 1px solid ${COLORS.text};
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const PhoneNumSelectButton = styled.select`
  font-size: 1.6rem;
  height: 40px;
  padding: 5px 10px;
  background-color: red;
  color: ${COLORS.text};

  outline: none;
  // height: 38px;
  width: 120px;
  margin-top: 8px;

  border: 1px solid ${COLORS.border};
  background: url(${DropdownArrow}) no-repeat right;
  appearance: none !important;
  background-size: 16px 16px !important;
  background-position: 95% 50% !important;
  cursor: pointer;
  border-radius: 4px 0 0 4px;
  padding-left: 35px;
  // padding-right: 25px;
  color: ${COLORS.textdark};
  border-right: none;

  :focus {
    border: 1px solid ${COLORS.text};
  }
  @media all and (max-width: 320px) {
    padding-left: 10px;
  }
`;

export const Select = styled.select`
  font-size: 1.4rem;
  height: 40px;
  padding: 5px 10px;
  color: ${COLORS.text};

  outline: none;
  width: 100%;
  // height: 20px;
  margin-top: 8px;
  // padding: 8px 16px;
  border: 1px solid ${COLORS.border};
  border-radius: 4px;
  background: url(${DropdownArrow}) no-repeat right;
  appearance: none !important;
  background-size: 16px 16px !important;
  background-position: 95% 50% !important;
  cursor: pointer;

  :focus {
    border: 1px solid ${COLORS.text};
  }
`;

export const FlagImg = styled.img`
  position: absolute;
  margin: 20px 10px;

  @media all and (max-width: 320px) {
    display: none;
  }
`;

export const PasswordInputElement = styled(Input)`
  margin-bottom: unset;
  border: 1px solid ${COLORS.border};
  border-color: ${props => (props.error ? "red" : COLORS.border2)};
`;

export const PasswordInputWrapper = styled.div`
  position: relative;

  & .togglePassword {
    position: absolute;
    top: 60%;
    right: 15px;
    transform: translateY(-50%);
    cursor: pointer;
  }
`;

export const ErrorSpan = styled.p`
  font-size: 1.2rem;
  color: red;
  margin: 5px 0 0;
`;
